import { Link, Stack, Tooltip, Typography, type SxProps } from "@mui/material";
import type React from "react";
import { Links, type ActionItemStatus } from "src/constants";
import type { ParentTeamDto } from "src/http";
import { isWhitespace } from "../textEditor";
import { ActionItemStatusPicker } from "./ActionItemStatusPicker";

interface Props {
  actionItemGuid: string;
  actionItemTeam: ParentTeamDto;
  actionItemDescription: string;
  actionItemStatus: ActionItemStatus;
  target?: React.HTMLAttributeAnchorTarget;
  onClick?: (e: React.MouseEvent) => void;
  sx?: SxProps;
}

const ActionItemLabel = (props: Props) => {
  return (
    <Stack direction="row" sx={{ ...props.sx }}>
      <ActionItemStatusPicker
        actionItemGuid={props.actionItemGuid}
        status={props.actionItemStatus}
        variant="button"
        disabled
        planGuid={""}
      />
      <Tooltip
        title={
          <Typography>
            <strong>{props.actionItemTeam.name}</strong>
            <span> : </span>

            <Link href={Links.ActionItemDetail(props.actionItemGuid)} target={props.target}>
              {props.actionItemDescription}
            </Link>
          </Typography>
        }
        placement="right"
      >
        <Link href={Links.ActionItemDetail(props.actionItemGuid)} target={props.target} onClick={props.onClick}>
          {props.actionItemDescription == null || isWhitespace(props.actionItemDescription) ? (
            <Typography variant="placeholder">Nothing here yet.</Typography>
          ) : (
            <Typography>{props.actionItemDescription}</Typography>
          )}
        </Link>
      </Tooltip>
    </Stack>
  );
};

export { ActionItemLabel };
